import {ModuleEnum} from 'src/api/ProactApiClient';
import {SafetyEventCustomOperations} from './customOperations';
import {useModulePermissions} from './useModulePermissions';

/**
 * Hook for SafetyEvent module permissions.
 * Includes standard operations plus SafetyEvent-specific custom operations for state transitions.
 */
export function useSafetyEventPermissions() {
  return useModulePermissions(ModuleEnum.SafetyEvent, SafetyEventCustomOperations);
}
